export const environment = {
  production: false,
  urlApi: 'https://admin.maltia.cleversecdesarrollo.app:5700/api',
};
